import React, { PropTypes } from 'react';
import Teaser from './Teaser';

const TeaserList = props => (
    <div key={1}>
        {props.items.map(Teaser)}
    </div>
);

TeaserList.displayName = 'TeaserList';
TeaserList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
};

export default TeaserList;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/TeaserList.js
 **/